import { Reveal } from "./Reveal";
import { BeforeAfterSlider } from "./BeforeAfterSlider";
import { SamplePdfStack } from "./SamplePdfStack";
import { ScaleToFit } from "./ScaleToFit";
import { CrossLink } from "./CrossLink";
import { hrefForUseCase } from "../../use-cases/links";
import {
  COMPARISON_SCREENSHOT,
  PDF_STACK_SIZE,
  PHONE_BEZEL,
  PHONE_SCREEN,
} from "./homeSample";

const PHONE_WIDTH = PHONE_SCREEN.width + PHONE_BEZEL * 2;
const PHONE_HEIGHT = PHONE_SCREEN.height + PHONE_BEZEL * 2;

/**
 * Before/after: the same Northfield data as a stack of vendor PDF pages, and
 * as a page of the sample narrative (a static screenshot, not a live
 * player). A draggable divider wipes between them.
 */
export const Comparison = () => (
  <section className="bg-white py-24 md:py-32 px-8 md:px-16 lg:px-20 relative overflow-hidden">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <span className="text-fwd-red text-xs font-bold tracking-[0.2em] uppercase block mb-5">
          The Transformation
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-[clamp(2.2rem,4vw,3.5rem)] font-normal leading-tight text-fwd-ink mb-12 md:mb-16">
          From PDFs and slideshows no one reads
          <br className="hidden md:block" /> to narratives everyone finishes.
        </h2>
      </Reveal>

      <BeforeAfterSlider
        className="aspect-[3/5] sm:aspect-[4/5] md:aspect-[16/10]"
        beforeLabel={
          <>
            Before<span className="hidden sm:inline"> · The annual PDF</span>
          </>
        }
        afterLabel={
          <>
            After<span className="hidden sm:inline"> · Their narrative</span>
          </>
        }
        before={
          <div className="w-full h-full bg-fwd-soft p-6 pt-16 md:p-12 md:pt-20">
            <ScaleToFit {...PDF_STACK_SIZE}>
              <SamplePdfStack />
            </ScaleToFit>
          </div>
        }
        after={
          <div className="w-full h-full bg-fwd-navy p-6 pt-16 md:p-10 md:pt-16">
            <ScaleToFit width={PHONE_WIDTH} height={PHONE_HEIGHT}>
              <div
                className="bg-fwd-ink rounded-[52px] shadow-[0_30px_80px_rgba(0,0,0,0.45),0_0_0_1px_rgba(255,255,255,0.08)]"
                style={{
                  width: PHONE_WIDTH,
                  height: PHONE_HEIGHT,
                  padding: PHONE_BEZEL,
                }}
              >
                <img
                  src={COMPARISON_SCREENSHOT}
                  alt="A page of Northfield Marketing's Year in Review narrative: “Q3 hit 115 hours,” over a bar chart of hours saved by quarter (81, 99, 115, 91) with the Q3 bar highlighted, and the note that Q3 was the peak."
                  width={PHONE_SCREEN.width}
                  height={PHONE_SCREEN.height}
                  loading="lazy"
                  decoding="async"
                  draggable={false}
                  className="block w-full h-full rounded-[38px] object-cover"
                />
              </div>
            </ScaleToFit>
          </div>
        }
      />
      <p className="text-fwd-mid text-xs text-center mt-4">
        Drag the handle to compare. The sample is a customer Year in Review,
        built for{" "}
        <CrossLink href={hrefForUseCase("customer-marketing")}>
          Customer Success teams
        </CrossLink>
        .
      </p>
    </div>
  </section>
);
